import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectClassicEmbedRoute: InvariantJiraRoute = {
	name: 'issue-navigator-classic-embed',
	path: '/jira/software/c/projects/:projectKey/issues/embed',
};
